import { SnippetType } from '@distribute/shared/types';
import { IconMap } from '../../../../../shared/sprite';

export const snippetMenuIconByType = {
  [SnippetType.IMAGE]: IconMap.SnippetMenuImg,
  [SnippetType.VIDEO]: IconMap.SnippetMenuVideo,
  [SnippetType.FILE]: IconMap.BlankPageSquare,
  [SnippetType.TEXT]: IconMap.SnippetMenuText,
};
